/* eslint-disable no-unused-vars */
/* eslint-disable yoda */
/* eslint-disable no-console */
import React, { useCallback } from 'react';

import { hostPauseListing, hostPauseAllListings, hostUnPauseListing, hostUnPauseAllListings } from '../api/pauseListingApi';

export const usePauseListingActions = () => {
  const handlePauseListing = async (listingId) => {
    try {
      await hostPauseListing(listingId);
    } catch (error) {
      return null;
    }
  };

  const handlePauseListings = async (spaceId) => {
    try {
      const response = await hostPauseAllListings(spaceId);
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const handleUnPauseListing = async (listingId) => {
    try {
      await hostUnPauseListing(listingId);
    } catch (error) {
      return null;
    }
  };

  const handleUnPauseListings = async (spaceId) => {
    try {
      const response = await hostUnPauseAllListings(spaceId);
      return response.data;
    } catch (error) {
      return null;
    }
  };

  return { handlePauseListing, handlePauseListings, handleUnPauseListing, handleUnPauseListings };
};
